export default __webpack_public_path__ + "static/media/rarity-common.c156c166.svg";